import * as Yup from 'yup';

const FundraisingTransactionValidator = () => Yup.object().shape({
  title: Yup.string().required(),
  ambassador_id: Yup.string(),
  contact_id: Yup.string().required(),
  donor_name_displayed: Yup.string(),
  amount_multiplier: Yup.string(),
  pledge_date: Yup.date(),
  source_reference: Yup.string(),
  source_reference_url: Yup.string(),
  donor_comment: Yup.string(),
});

export default FundraisingTransactionValidator;
